// src/components/Modales/ModalBase.jsx
import React from "react";
import { FaTimes } from "react-icons/fa";

export default function ModalBase({ title, children, onClose, footer = null }) {
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-md" onClick={(e) => e.stopPropagation()}>
        {/* HEADER */}
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">{title}</h2>
          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* BODY */}
        <div className="modal-body space-y-5">{children}</div>

        {/* FOOTER (opcional) */}
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}
